var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDaishouhuo = function SvgDaishouhuo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "daishouhuo_svg__a",
    d: "M0 0h26v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "daishouhuo_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#daishouhuo_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m22.137 19.943.07-1.443h2.277V1.572H7v5.446c0 .67-.42 1.092-1.046 1.294L1.5 9.752v7.689c0 .276-.294.5-.57.5H.5a.5.5 0 0 1-.5-.5V9.522c0-.67.421-1.256 1.048-1.458L5.5 6.626V1.529C5.5.686 6.173 0 7 0h17c1.102 0 2 .924 2 2.059v15.882C26 19.076 25.102 20 24 20l-1.863-.057Z",
    fill: "#333",
    mask: "url(#daishouhuo_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 20.5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2M6.458 26c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5M19.5 20.5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m-.042 5.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5M7.1 15.05a.5.5 0 0 1-.5-.5V14a.5.5 0 0 1 .5-.5h3.38v-3.45c0-.275.226-.5.5-.5h.551c.274 0 .5.225.5.5v4.5c0 .275-.226.5-.5.5H7.1Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M9 21.5h8V23H9z"
  }))));
};

export default SvgDaishouhuo;